import { Document, Image, Page, Text, View } from '@react-pdf/renderer';
import React from 'react';
import osvielLogo from '../../../assets/img/logos/osviel.jpg';
import { PIE_PAGINA } from '../../solicitud/formato/legalText';
import {
    ACREEDOR,
    construirCierre,
    construirClausulas,
    construirComparecencia,
    TITULO
} from './contratoText';
import styles from './styles';

const Header = () => (
    <View style={styles.header} fixed>
        <Image style={styles.logo} src={osvielLogo} />
        <Text style={styles.tagline}>Su Operadora de Libranza / NIT {ACREEDOR.nit}</Text>
    </View>
);

const Footer = () => (
    <>
        <View style={styles.footer} fixed>
            {PIE_PAGINA.map((linea, i) => (
                <Text key={i}>{linea}</Text>
            ))}
        </View>
        <Text
            style={styles.paginado}
            fixed
            render={({ pageNumber, totalPages }) => `Página ${pageNumber} de ${totalPages}`}
        />
    </>
);

const Clausula = ({ clausula }) => (
    <View>
        <Text style={styles.clausulaTitulo}>{clausula.titulo}</Text>
        {clausula.parrafos.map((parrafo, i) => (
            <Text key={i} style={styles.parrafo}>{parrafo}</Text>
        ))}
        {(clausula.items || []).map((item, i) => (
            <Text key={i} style={styles.item}>{item}</Text>
        ))}
        {(clausula.cierre || []).map((parrafo, i) => (
            <Text key={i} style={[styles.parrafo, { marginTop: 6 }]}>{parrafo}</Text>
        ))}
    </View>
);

const Firmas = ({ deudor }) => (
    <View style={styles.firmasRow}>
        <View style={styles.firmaCol}>
            <Text style={styles.firmaRol}>EL ACREEDOR</Text>
            <View style={styles.firmaLinea}>
                <Text style={styles.firmaNombre}>{ACREEDOR.representante}</Text>
                <Text style={styles.firmaDato}>
                    C.C. No. {ACREEDOR.cedulaRepresentante} de {ACREEDOR.lugarExpedicionRepresentante}
                </Text>
                <Text style={styles.firmaDato}>{ACREEDOR.cargoRepresentante}</Text>
                <Text style={styles.firmaDato}>{ACREEDOR.razonSocial}</Text>
                <Text style={styles.firmaDato}>NIT: {ACREEDOR.nit}</Text>
            </View>
        </View>
        <View style={styles.firmaCol}>
            <Text style={styles.firmaRol}>EL DEUDOR</Text>
            <View style={styles.firmaLinea}>
                <Text style={styles.firmaNombre}>{deudor.nombre}</Text>
                <Text style={styles.firmaDato}>
                    {deudor.tipoDocumentoCorto} No. {deudor.identificacion} de {deudor.lugarExpedicion}
                </Text>
            </View>
        </View>
    </View>
);

const ContratoNovacion = ({ data }) => {
    if (!data) return null;

    const clausulas = construirClausulas(data);

    return (
        <Document title={`Contrato de novación ${data.credito.numero || ''}`}>
            <Page size="A4" style={styles.page}>
                <Header />
                <Text style={styles.titulo}>{TITULO}</Text>
                <Text style={styles.parrafo}>{construirComparecencia(data)}</Text>
                {clausulas.map(clausula => (
                    <Clausula key={clausula.titulo} clausula={clausula} />
                ))}
                {/* Cierre y firmas viajan juntos y sin partirse: una página final
                    con las rúbricas sueltas es motivo de rechazo en jurídica. */}
                <View wrap={false}>
                    <Text style={styles.cierre}>{construirCierre(data)}</Text>
                    <Firmas deudor={data.deudor} />
                </View>
                <Footer />
            </Page>
        </Document>
    );
};

export default ContratoNovacion;
